var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319387",
    clipPath: "url(#clip0_45_1357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 703",
    d: "M8 0.440063L8 15.7182",
    stroke: "#626262",
    strokeDasharray: "2 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 100",
    d: "M8.00001 11.0889C4.05577 11.0889 0.858337 9.5903 0.858337 7.74173C0.858337 5.89316 4.05577 4.39459 8.00001 4.39459C11.9442 4.39459 15.1417 5.89316 15.1417 7.74173C15.1417 8.92536 13.8308 9.96549 11.8524 10.5606",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 700",
    d: "M6.61968 11.6919L6.56252 10.0977L8.98998 10.7288L6.61968 11.6919Z",
    fill: "#626262",
    stroke: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_1357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate2);
export default __webpack_public_path__ + "static/media/rotate2.c8da5ab6e477038de245f4843b8f6ada.svg";
export { ForwardRef as ReactComponent };